import * as React from 'react';

// styles
import './footer-logo.styles.less';

export interface IFooterLogoProps {
    href: string;
    className: string;
    onClick?: () => void;
}

export const FooterLogo: React.FC<IFooterLogoProps> = props => (
    <div className={`sitegen-footer-logo ${props.className}`}>
        <a
            className="sitegen-footer-logo__link"
            href={props.href}
            target="_blank"
            rel="noreferrer"
            onClick={props.onClick}
        />
    </div>
);

FooterLogo.defaultProps = {
    className: '',
    href: '#'
};

export default FooterLogo;
